/**
 * @file  helper.js
 *
 * @author hongyang03
 */

import $ from 'jquery';
import 'jquery.cookie';

export const isOnline = /market\.baidu\.com/.test(window.location.hostname);

// 获取UUID
export const getUUID = () => {
    let s = [];
    let hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4';
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = '-';
    let uuid = s.join('');
    return uuid;
};

// 加密
export const base64Encode = str => {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            return String.fromCharCode('0x' + p1);
        }));
};

// 解密
export const base64Decode = str => {
    return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
};

// 是否登录
export const isLogin = async () => {
    let domain = isOnline ? 'https://bce.baidu.com' : 'https://bcetest.baidu.com';
    let options = {
        url: domain + '/api/account/v2/displayName',
        dataType: 'jsonp',
        timeout: 3000,
        withCredentials: true
    };
    let response = await $.ajax(options);
    const result = response && response.result || {};
    const isLogin = result.hasLogin === true;
    if (isLogin) {
        const host = window.location.hostname;
        const cookies = result.cookies || {};
        const clientCookies = cookies['bce-ctl-client-cookies']
            ? cookies['bce-ctl-client-cookies'].slice(1, -1).split(',') : [];
        const sessionId = cookies['bce-sessionid'] || '';
        const bceAuthType = cookies['bce-auth-type'] || '';
        $.cookie('bce-sessionid', sessionId, {path: '/', domain: '.' + host});
        $.cookie('bce-auth-type', bceAuthType, {path: '/', domain: '.' + host});
        clientCookies.forEach(element => {
            const cookieValue = cookies[element] || '';
            $.cookie(element, cookieValue, {path: '/', domain: '.' + host});
        });
    }
    return Promise.resolve(response);
};
